import React, { useEffect } from 'react';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { reimbursementCategoryId, reimbursementCategory } from 'app/models/Placement/PlacementMods';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';

export const Category = ({ options, isModEdit }: { options: any; isModEdit: boolean }) => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const reimbursementCategoryValue = useWatch<any>({ name: reimbursementCategoryId });
  const isUndoModal = useSelector(selectIsUndoModal);
  const dispatch = useDispatch();
  let initialState = true;
  const handleValueChanged = value => {
    setValue(reimbursementCategory, value);
    const selectedValue = options?.find(item => item.Description === value);
    setValue(reimbursementCategoryId, selectedValue?.ID ? parseInt(selectedValue?.ID) : '');
    if (value) {
      clearErrors(reimbursementCategory);
      clearErrors('initialCategory');
    }
    initialState = false;
  };

  useEffect(() => {
    const value = options?.find(item => parseInt(item.ID) === reimbursementCategoryValue)?.Description;
    setValue(reimbursementCategory, value ?? '');
    if (isModEdit && isNullOrUndefined(value) && initialState) {
      setError('initialCategory', {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  }, [options, isUndoModal]);

  return (
    <>
      <Controller
        control={control}
        name={reimbursementCategoryId}
        rules={{ required: isModEdit }}
        render={({ field: { onChange, ...rest } }) => {
          return (
            <FormInputDropdown
              disabledOptions={options.filter(x => !x.Active)}
              name={reimbursementCategory}
              label={`Category *`}
              require={true}
              standard={true}
              options={options ?? []}
              inputValue={getValues(reimbursementCategory) ?? null}
              readOnly={!isModEdit}
              handleChange={e => {
                onChange(e);
                handleValueChanged(e.target.value);
              }}
            ></FormInputDropdown>
          );
        }}
      />
    </>
  );
};
